import { Space, Tag, Typography } from 'antd'
import dayjs from 'dayjs'

import {
  AuctionOperationPageStatus,
  AuctionOperationPageStatusColorMap,
  AuctionOperationPageStatusTextMap
} from '../../../enums/AuctionOperationPageStatus'

import { AuctionListStatusRenderProps } from './interface'

export const AuctionListStatusRender = ({
  record: { status = AuctionOperationPageStatus.WAIT_AUDIT, createdTime }
}: AuctionListStatusRenderProps) => {
  return (
    <Space orientation='vertical' size='small'>
      <Tag color={AuctionOperationPageStatusColorMap[status]} variant='filled'>
        {AuctionOperationPageStatusTextMap[status]}
      </Tag>
      {status === AuctionOperationPageStatus.WAIT_AUDIT && (
        <Typography.Text style={{ color: 'orange' }}>
          {dayjs(createdTime).fromNow()}
        </Typography.Text>
      )}
    </Space>
  )
}
